import { get } from 'lodash';
import React, { memo } from 'react';
import { Field } from 'formik';
import Check from '@material-ui/icons/Check';
import { SUCCESS } from 'styles/colors';

const FormField = ({ children, component: Component, name, ...props }) => (
  <Field name={name}>
    {({ field, form }) => {
      const { submitCount, touched, errors } = form;
      const { onChange, onBlur, value, ...fieldProps } = field;
      const error = get(errors, name, '') || props.specificerror;
      const canValidate = Boolean(props.specificerror || submitCount > 0 || get(touched, name))
      const isValid = Boolean(canValidate && !error);
      const hasError = Boolean(canValidate && error);
      const handleChange = props.onChange || onChange;

      return (
        <Component
          {...fieldProps}
          onChange={handleChange}
          onBlur={props.onBlur || onBlur}
          error={hasError}
          helperText={hasError && error}
          defaultValue={value}
          {...props}
          InputProps={{
            ...props.InputProps,
            ...(isValid
              ? { endAdornment: <Check position="end" style={{ color: SUCCESS }} /> }
              : {}
            )
          }}
        >
          {children}
        </Component>
      );
    }}
  </Field >
);

export default memo(FormField);
